/**
 * 系统图标统一配置
 * _N 表示普通状态下的图标
 * _V 表示高亮状态下的图标
 */
import PRMSL_N from '@/assets/shipIcons/oceantool/PRMSL_N.png';
import PRMSL_V from '@/assets/shipIcons/oceantool/PRMSL_V.png';

import WIND10M_N from '@/assets/shipIcons/oceantool/WIND10M_N.png';
import WIND10M_V from '@/assets/shipIcons/oceantool/WIND10M_V.png';

import WAVE_N from '@/assets/shipIcons/oceantool/WAVE_N.png';
import WAVE_V from '@/assets/shipIcons/oceantool/WAVE_V.png';

import sf_N from '@/assets/shipIcons/drawable/bmyl.png';
import sf_V from '@/assets/shipIcons/drawable/bmyl.png';

import sst_N from '@/assets/shipIcons/drawable/biaowen.png';
import sst_V from '@/assets/shipIcons/drawable/biaowen.png';

import ssta_N from '@/assets/shipIcons/oceantool/SSTA_N.png';
import ssta_V from '@/assets/shipIcons/oceantool/SSTA_V.png';

import ssh_N from '@/assets/shipIcons/oceantool/SSH_N.png';
import ssh_V from '@/assets/shipIcons/oceantool/SSH_V.png';

import ssha_N from '@/assets/shipIcons/oceantool/SSHA_N.png';
import ssha_V from '@/assets/shipIcons/oceantool/SSHA_V.png';

import chla_N from '@/assets/shipIcons/oceantool/chla_N.png';
import chla_V from '@/assets/shipIcons/oceantool/chla_V.png';

import CURRENT_N from '@/assets/shipIcons/oceantool/CURRENT_N.png';
import CURRENT_V from '@/assets/shipIcons/oceantool/CURRENT_V.png';

import CURRENT0_N from '@/assets/shipIcons/drawable/yl0m_hui.png';
import CURRENT0_V from '@/assets/shipIcons/drawable/yl0m_lan.png';

import CURRENT50_N from '@/assets/shipIcons/drawable/yl50m_hui.png';
import CURRENT50_V from '@/assets/shipIcons/drawable/yl50m_lan.png';

import CURRENT100_N from '@/assets/shipIcons/drawable/yl100m_hui.png';
import CURRENT100_V from '@/assets/shipIcons/drawable/yl100m_lan.png';

import CURRENT200_N from '@/assets/shipIcons/drawable/yl200m_hui.png';
import CURRENT200_V from '@/assets/shipIcons/drawable/yl200m_lan.png';

import CURRENT300_N from '@/assets/shipIcons/drawable/yl300m_hui.png';
import CURRENT300_V from '@/assets/shipIcons/drawable/yl300m_lan.png';

import TMP_N from '@/assets/shipIcons/oceantool/TMP_N.png';
import TMP_V from '@/assets/shipIcons/oceantool/TMP_V.png';

import TMP0_N from '@/assets/shipIcons/drawable/sw0m_hui.png';
import TMP0_V from '@/assets/shipIcons/drawable/sw0m_lan.png';

import TMP50_N from '@/assets/shipIcons/drawable/sw50m_hui.png';
import TMP50_V from '@/assets/shipIcons/drawable/sw50m_lan.png';

import TMP100_N from '@/assets/shipIcons/drawable/sw100m_hui.png';
import TMP100_V from '@/assets/shipIcons/drawable/sw100m_lan.png';

import TMP200_N from '@/assets/shipIcons/drawable/sw200m_hui.png';
import TMP200_V from '@/assets/shipIcons/drawable/sw200m_lan.png';

import TMP300_N from '@/assets/shipIcons/drawable/sw300m_hui.png';
import TMP300_V from '@/assets/shipIcons/drawable/sw300m_lan.png';


import WARN_N from '@/assets/shipIcons/buttons/WARN_N.png';
import WARN_V from '@/assets/shipIcons/buttons/WARN_V.png';

import fengxian_N from '@/assets/shipIcons/buttons/FENGMIAN_N.png';
import fengxian_V from '@/assets/shipIcons/buttons/FENGMIAN_V.png';

import WINDALARM_N from '@/assets/shipIcons/buttons/WINDWARN_N.png';
import WINDALARM_V from '@/assets/shipIcons/buttons/WINDWARN_V.png';


import WAVEALARM_N from '@/assets/shipIcons/buttons/WAVEWARN_N.png';
import WAVEALARM_V from '@/assets/shipIcons/buttons/WAVEWARN_V.png';

import TYPHOON_N from '@/assets/shipIcons/oceantool/TYPHOON_N.png';
import TYPHOON_V from '@/assets/shipIcons/oceantool/TYPHOON_V.png';

//经纬网格
import LL_N from '@/assets/shipIcons/layercontrol/LL_N.png';
import LL_V from '@/assets/shipIcons/layercontrol/LL_V.png';
//全球经济圈
import ENC_N from '@/assets/shipIcons/layercontrol/ENC_N.png';
import ENC_V from '@/assets/shipIcons/layercontrol/ENC_V.png';
//船舶点
import SHIP_N from '@/assets/shipIcons/layercontrol/SHIP_N.png';

import SHIP_V from '@/assets/shipIcons/layercontrol/SHIP_V.png';
//港口
import SHIPORT_N from '@/assets/shipIcons/layercontrol/SHIPORT_N.png';
import SHIPORT_V from '@/assets/shipIcons/layercontrol/SHIPORT_V.png';
//鼠标绘制
import POLYGON_N from '@/assets/shipIcons/maptool/POLYGON_N.png';
import POLYGON_V from '@/assets/shipIcons/maptool/POLYGON_V.png';
//距离测量
import DISTANCE_N from '@/assets/shipIcons/maptool/DISTANCE_N.png';
import DISTANCE_V from '@/assets/shipIcons/maptool/DISTANCE_V.png';
//坐标定位
import POSITION_N from '@/assets/shipIcons/maptool/POSITION_N.png';
import POSITION_V from '@/assets/shipIcons/maptool/POSITION_V.png';

//缩小
import ZOOMOUT_N from '@/assets/shipIcons/maptool/ZOOMOUT_N.png';
import ZOOMOUT_V from '@/assets/shipIcons/maptool/ZOOMOUT_V.png';

//放大
import ZOOMIN_N from '@/assets/shipIcons/maptool/ZOOMIN_N.png';
import ZOOMIN_V from '@/assets/shipIcons/maptool/ZOOMIN_V.png';

//km
import KM_N from '@/assets/shipIcons/maptool/KM_N.png';
import KM_V from '@/assets/shipIcons/maptool/KM_V.png';

//nm
import NM_N from '@/assets/shipIcons/maptool/NM_N.png';
import NM_V from '@/assets/shipIcons/maptool/NM_V.png';



/********************layercontrol******************* */
//清除绘制
import CLEAR_N from '@/assets/shipIcons/maptool/CLEAR_N.png';
import CLEAR_V from '@/assets/shipIcons/maptool/CLEAR_V.png';

//用户
import USER_N from '@/assets/shipIcons/layercontrol/USER_N.png';
import USER_V from '@/assets/shipIcons/layercontrol/USER_V.png';
//渔船绘制
import DRAW_FISHER from '@/assets/shipIcons/layercontrol/DRAW_FISHER.png';
//渔船预报
import FISHER_PRE from '@/assets/shipIcons/layercontrol/FISHER_PRE.png';
//渔船筛选
import FILTER_FISHER from '@/assets/shipIcons/layercontrol/FILTER_FISHER.png';
//渔捞日志
import FISHER_LOG from '@/assets/shipIcons/layercontrol/FISHER_LOG.png';
//修改密码
import CHANGE_PASS from '@/assets/shipIcons/layercontrol/CHANGE_PASS.png';
//渔情制图
import PERFISSION_PIC from '@/assets/shipIcons/layercontrol/PERFISSION_PIC.png';



//卫星图
import WMAP_N from '@/assets/shipIcons/buttons/WMAP.png';
import WMAP_V from '@/assets/shipIcons/buttons/WMAP.png';

//矢量图
import NMAP_N from '@/assets/shipIcons/buttons/NMAP.png';
import NMAP_V from '@/assets/shipIcons/buttons/NMAP.png';

//海图
import SMAP_N from '@/assets/shipIcons/buttons/SMAP.png';
import SMAP_V from '@/assets/shipIcons/buttons/SMAP.png';



//船舶图
import SHIPICON_N from '@/assets/shipIcons/icons/SHIP_N.png';
import SHIPICON_NO from '@/assets/shipIcons/icons/SHIP_NO.png';

import KOREA_SHIP_N from '@/assets/shipIcons/icons/KOREA_SHIP_N.png';
import KOREA_SHIP_H from '@/assets/shipIcons/icons/KOREA_SHIP_H.png';
import JAPAN_SHIP_N from '@/assets/shipIcons/icons/JAPAN_SHIP_N.png';
import JAPAN_SHIP_H from '@/assets/shipIcons/icons/JAPAN_SHIP_H.png';
import TAIPEI_SHIP_N from '@/assets/shipIcons/icons/TAIPEI_SHIP_N.png';
import TAIPEI_SHIP_H from '@/assets/shipIcons/icons/TAIPEI_SHIP_H.png';

import SHIPICON_V from '@/assets/shipIcons/icons/SHIP_Vx.png';
import SHIPICON_VO from '@/assets/shipIcons/icons/SHIP_VO.png';


//港口图
import SHIPORTICON_N from '@/assets/shipIcons/icons/SHIPORT_N.png';
import SHIPORTICON_V from '@/assets/shipIcons/icons/SHIPORT_V.png';

import LOGO from '@/assets/shipIcons/logo.png';


import CHLA_LG from '@/assets/shipIcons/legend/CHLA.png';
import rtofs_LG from '@/assets/shipIcons/legend/rtofs.png';
import rtofst_LG from '@/assets/shipIcons/legend/rtofst.png';
import rtofsuv_LG from '@/assets/shipIcons/legend/rtofsuv.png';
import SF_LG from '@/assets/shipIcons/legend/SF.png';
import SSH_LG from '@/assets/shipIcons/legend/SSH.png';
import SSHA_LG from '@/assets/shipIcons/legend/SSHA.png';
import SST_LG from '@/assets/shipIcons/legend/SST.png';
import SSTA_LG from '@/assets/shipIcons/legend/SSTA.png';
import Typhoon_LG from '@/assets/shipIcons/legend/Typhoon.png';
import WAVE_LG from '@/assets/shipIcons/legend/WAVE.png';
import WIND10M_LG from '@/assets/shipIcons/legend/WIND10M.png';



import FOCUS_N from '@/assets/shipIcons/buttons/FOCUS_N.png';
import FOCUS_V from '@/assets/shipIcons/buttons/FOCUS_V.png';

import START from '@/assets/shipIcons/icons/START.png';
import END from '@/assets/shipIcons/icons/END.png';

///用于单点查询
import singlehyysbw from '@/assets/shipIcons/mipmap-xhdpi/hyysbw.png';
import singlehyysbwjp from '@/assets/shipIcons/mipmap-xhdpi/hyysbwjp.png';
import singlehyysfc from '@/assets/shipIcons/mipmap-xhdpi/hyysfc.png';
import singlehyysgdjp from '@/assets/shipIcons/mipmap-xhdpi/hyysgdjp.png';
import singlehyyshl from '@/assets/shipIcons/mipmap-xhdpi/hyyshl.png';
import singlehyyshmgd from '@/assets/shipIcons/mipmap-xhdpi/hyyshmgd.png';
import singlehyysqy from '@/assets/shipIcons/mipmap-xhdpi/hyysqy.png';
import singlehyyssw from '@/assets/shipIcons/mipmap-xhdpi/hyyssw.png';
import singlehyysyl from '@/assets/shipIcons/mipmap-xhdpi/hyysyl.png';
import singlehyysyls from '@/assets/shipIcons/mipmap-xhdpi/hyysyls.png';
import singlehyysbmyl from '@/assets/shipIcons/mipmap-xhdpi/hyysbmyl.png';

import SINGLE_N from '@/assets/shipIcons/oceantool/SINGLE_N.png';
import SINGLE_V from '@/assets/shipIcons/oceantool/SINGLE_V.png';

///点击地图添加的位置图片
import dangqianweizhi from '@/assets/shipIcons/icons/POS2.png';

//渔场
import FISH_N from '@/assets/shipIcons/buttons/FISH_N.png';
import FISH_V from '@/assets/shipIcons/buttons/FISH_V.png';


//关闭
import CLOSE_N from '@/assets/shipIcons/buttons/CLOSE_N.png';
import CLOSE_V from '@/assets/shipIcons/buttons/CLOSE_V.png';

import INFO from '@/assets/shipIcons/icons/info.png';
import POS from '@/assets/shipIcons/icons/pos.png';
import BOAT from '@/assets/shipIcons/icons/boat.png';

import ADD from '@/assets/shipIcons/buttons/+.png';
import SUBTRACT from '@/assets/shipIcons/buttons/-.png';
import SINGLECHART from '@/assets/shipIcons/buttons/SINGLECHART.png';
import SINGLEVCHART from '@/assets/shipIcons/buttons/SINGLEVCHART.png';
import BOAT_N from '@/assets/shipIcons/icons/boat1_N.png';
import BOAT_V from '@/assets/shipIcons/icons/boat1_V.png';
import FOLDER from '@/assets/shipIcons/icons/folder.png';

import SEARCH_N from '@/assets/shipIcons/buttons/SEARCH_N.png';
import SEARCH_V from '@/assets/shipIcons/buttons/SEARCH_V.png';
import MENU_N from '@/assets/shipIcons/buttons/MENU_N.png';
import MENU_V from '@/assets/shipIcons/buttons/MENU_V.png';

import SHRINK from '@/assets/shipIcons/buttons/SHRINK.png';
import EXPAND from '@/assets/shipIcons/buttons/EXPAND.png';


import CHAT from '@/assets/shipIcons/buttons/CHAT.png';
import FLOG from '@/assets/shipIcons/buttons/FLOG.png';

import ADDRESS from '@/assets/shipIcons/buttons/address.png';

import LEFT_N from '@/assets/shipIcons/buttons/LEFT_N.png';
import LEFT_V from '@/assets/shipIcons/buttons/LEFT_V.png';
import RIGHT_N from '@/assets/shipIcons/buttons/RIGHT_N.png';
import RIGHT_V from '@/assets/shipIcons/buttons/RIGHT_V.png';



// import MOUSE from '@/assets/shipIcons/icons/info.cur';
import MOUSE from '@/assets/shipIcons/icons/mouse.png';

import PANMOUSE from '@/assets/shipIcons/icons/openhand.png';
import PANDOWNMOUSE from '@/assets/shipIcons/icons/closedhand.png';


import LAYER_N from '@/assets/shipIcons/buttons/LAYER_N.png';
import LAYER_V from '@/assets/shipIcons/buttons/LAYER_V.png';


import DETAIL_N from '@/assets/shipIcons/layercontrol/DETAIL_N.png';
import DETAIL_V from '@/assets/shipIcons/layercontrol/DETAIL_V.png';


import LOGINOUT_N from '@/assets/shipIcons/layercontrol/LOGINOUT_N.png';
import LOGINOUT_V from '@/assets/shipIcons/layercontrol/LOGINOUT_V.png';

import HELP_N from '@/assets/shipIcons/layercontrol/HELP_N.png';
import HELP_V from '@/assets/shipIcons/layercontrol/HELP_V.png';


import TOOL_N from '@/assets/shipIcons/layercontrol/TOOL_N.png';
import TOOL_V from '@/assets/shipIcons/layercontrol/TOOL_V.png';



import LABEL from '@/assets/shipIcons/buttons/LABEL.png';
import TRIALICON from '@/assets/shipIcons/buttons/TRIALICON.png';
import ARROW from '@/assets/shipIcons/icons/arrow.png';

//编辑
import EDIT_N from '@/assets/shipIcons/drawtool/EDIT_N.png';
import EDIT_V from '@/assets/shipIcons/drawtool/EDIT_V.png';

//删除选中
import DELETE_N from '@/assets/shipIcons/drawtool/DELETE_N.png';
import DELETE_V from '@/assets/shipIcons/drawtool/DELETE_V.png';
//停止绘制
import STOPDRAW_N from '@/assets/shipIcons/drawtool/STOPDRAW_N.png';
import STOPDRAW_V from '@/assets/shipIcons/drawtool/STOPDRAW_V.png';

//渔区绘制
import FISHONE_N from '@/assets/shipIcons/drawtool/FISHONE_N.png';
import FISHONE_V from '@/assets/shipIcons/drawtool/FISHONE_V.png';
import FISHTWO_N from '@/assets/shipIcons/drawtool/FISHTWO_N.png';
import FISHTWO_V from '@/assets/shipIcons/drawtool/FISHTWO_V.png';
import FISHTHREE_N from '@/assets/shipIcons/drawtool/FISHTHREE_N.png';
import FISHTHREE_V from '@/assets/shipIcons/drawtool/FISHTHREE_V.png';

import DRAWRECT_N from '@/assets/shipIcons/drawtool/DRAWRECT_N.png';
import DRAWRECT_V from '@/assets/shipIcons/drawtool/DRAWRECT_V.png';

import DRAWARROW_N from '@/assets/shipIcons/drawtool/DRAWARROW_N.png';
import DRAWARROW_V from '@/assets/shipIcons/drawtool/DRAWARROW_V.png';


import DRAWWORD_N from '@/assets/shipIcons/drawtool/DRAWWORD_N.png';
import DRAWWORD_V from '@/assets/shipIcons/drawtool/DRAWWORD_V.png';

import DRAWLINE_N from '@/assets/shipIcons/drawtool/DRAWLINE_N.png';
import DRAWLINE_V from '@/assets/shipIcons/drawtool/DRAWLINE_V.png';

import SWITCH_N from '@/assets/shipIcons/buttons/SWITCH_N.png';
import SWITCH_V from '@/assets/shipIcons/buttons/SWITCH_V.png';

import LINE from '@/assets/shipIcons/icons/LINE.png';

import FISHERRECT_N from '@/assets/shipIcons/buttons/FISHERRECT_N.png';
import FISHERRECT_V from '@/assets/shipIcons/buttons/FISHERRECT_V.png';

import SHARE from '@/assets/shipIcons/buttons/SHARE.png';


//播放/暂停
import STOP from '@/assets/shipIcons/buttons/STOP.png';
import PLAY from '@/assets/shipIcons/buttons/PLAY.png';

//媒体按钮图片
import PLAY_1 from '@/assets/shipIcons/buttons/play_1.png'
import STOP_1 from '@/assets/shipIcons/buttons/stop_1.png'
import Z from '@/assets/shipIcons/buttons/z.png'
import Y from '@/assets/shipIcons/buttons/y.png'

// 历史产量图标
import HISTORY_NULL1 from '@/assets/img/x.png'
import HISTORY_NULL2 from '@/assets/img/x@2x.png'
import HISTORY_NULL3 from '@/assets/img/x@3x.png'
import HISTORY_ONE1 from '@/assets/img/组 36 拷贝.png'
import HISTORY_ONE2 from '@/assets/img/组 36 拷贝@2x.png'
import HISTORY_ONE3 from '@/assets/img/组 36 拷贝@3x.png'
import HISTORY_TWO1 from '@/assets/img/组 36 拷贝 2.png'
import HISTORY_TWO2 from '@/assets/img/组 36 拷贝 2@2x.png'
import HISTORY_TWO3 from '@/assets/img/组 36 拷贝 2@3x.png'
import HISTORY_THREE1 from '@/assets/img/组 36 拷贝 3.png'
import HISTORY_THREE2 from '@/assets/img/组 36 拷贝 3@2x.png'
import HISTORY_THREE3 from '@/assets/img/product.png'
import HISTORY_FOUR1 from '@/assets/img/组 36 拷贝 4.png'
import HISTORY_FOUR2 from '@/assets/img/组 36 拷贝 4@2x.png'
import HISTORY_FOUR3 from '@/assets/img/组 36 拷贝 4@3x.png'
import ZSA from '@/assets/img/zs_a.png'
import ZSB from '@/assets/img/zs_b.png'
import ZSC from '@/assets/img/zs_c.png'
import ZSD from '@/assets/img/zs_d.png'

// 行为分析
import BEHAVIOR_ANALYSIS from '@/assets/img/behavior_analysis.png'
// 专题图
import ZTT from '@/assets/img/ztt.png'

let sysIconConf = {
    // 历史产量
    HISTORY_NULL1: HISTORY_NULL1,
    HISTORY_NULL2: HISTORY_NULL2,
    HISTORY_NULL3: HISTORY_NULL3,
    HISTORY_ONE1: HISTORY_ONE1,
    HISTORY_ONE2: HISTORY_ONE2,
    HISTORY_ONE3: HISTORY_ONE3,
    HISTORY_TWO1: HISTORY_TWO1,
    HISTORY_TWO2: HISTORY_TWO2,
    HISTORY_TWO3: HISTORY_TWO3,
    HISTORY_THREE1: HISTORY_THREE1,
    HISTORY_THREE2: HISTORY_THREE2,
    HISTORY_THREE3: HISTORY_THREE3,
    HISTORY_FOUR1: HISTORY_FOUR1,
    HISTORY_FOUR2: HISTORY_FOUR2,
    HISTORY_FOUR3: HISTORY_FOUR3,
    ZSA: ZSA,
    ZSB: ZSB,
    ZSC: ZSC,
    ZSD: ZSD,
    LOGO: LOGO,
    //气压
    PRMSL_N: PRMSL_N,
    PRMSL_V: PRMSL_V,
    //风场
    WIND10M_N: WIND10M_N,
    WIND10M_V: WIND10M_V,
    //海浪
    WAVE_N: WAVE_N,
    WAVE_V: WAVE_V,
    sf_N: sf_N,
    sf_V: sf_V,
    sst_N: sst_N,
    sst_V: sst_V,
    ssta_N: ssta_N,
    ssta_V: ssta_V,
    ssh_N: ssh_N,
    ssh_V: ssh_V,

    ssha_N: ssha_N,
    ssha_V: ssha_V,

    chla_N: chla_N,
    chla_V: chla_V,

    CURRENT_N: CURRENT_N,
    CURRENT_V: CURRENT_V,

    CURRENT0_N: CURRENT0_N,
    CURRENT0_V: CURRENT0_V,

    CURRENT50_N: CURRENT50_N,
    CURRENT50_V: CURRENT50_V,

    CURRENT100_N: CURRENT100_N,
    CURRENT100_V: CURRENT100_V,

    CURRENT200_N: CURRENT200_N,
    CURRENT200_V: CURRENT200_V,

    CURRENT300_N: CURRENT300_N,
    CURRENT300_V: CURRENT300_V,

    TMP_N: TMP_N,
    TMP_V: TMP_V,

    TMP0_N: TMP0_N,
    TMP0_V: TMP0_V,

    TMP50_N: TMP50_N,
    TMP50_V: TMP50_V,

    TMP100_N: TMP100_N,
    TMP100_V: TMP100_V,

    TMP200_N: TMP200_N,
    TMP200_V: TMP200_V,

    TMP300_N: TMP300_N,
    TMP300_V: TMP300_V,

    WARN_N: WARN_N,
    WARN_V: WARN_V,

    fengxian_N: fengxian_N,
    fengxian_V: fengxian_V,

    WINDALARM_N: WINDALARM_N,
    WINDALARM_V: WINDALARM_V,


    WAVEALARM_N: WAVEALARM_N,
    WAVEALARM_V: WAVEALARM_V,

    TYPHOON_N: TYPHOON_N,
    TYPHOON_V: TYPHOON_V,

    //经纬网格
    LL_N: LL_N,
    LL_V: LL_V,
    //全球经济圈
    ENC_N: ENC_N,
    ENC_V: ENC_V,
    //船舶点网格
    SHIP_N: SHIP_N,
    SHIP_V: SHIP_V,
    //港口
    SHIPORT_N: SHIPORT_N,
    SHIPORT_V: SHIPORT_V,
    //鼠标绘制
    POLYGON_N: POLYGON_N,
    POLYGON_V: POLYGON_V,
    //距离测量
    DISTANCE_N: DISTANCE_N,
    DISTANCE_V: DISTANCE_V,
    POSITION_N: POSITION_N,
    POSITION_V: POSITION_V,
    ZOOMOUT_N: ZOOMOUT_N,
    ZOOMOUT_V: ZOOMOUT_V,
    ZOOMIN_N: ZOOMIN_N,
    ZOOMIN_V: ZOOMIN_V,

    KM_N: KM_N,
    KM_V: KM_V,
    NM_N: NM_N,
    NM_V: NM_V,

    //清除绘制
    CLEAR_N: CLEAR_N,
    CLEAR_V: CLEAR_V,

    //用户
    USER_N: USER_N,
    USER_V: USER_V,

    //用户
    SHIPICON_N: SHIPICON_N,
    SHIPICON_NO: SHIPICON_NO,
    SHIPICON_V: SHIPICON_V,
    SHIPICON_VO: SHIPICON_VO,
    JAPAN_SHIP_H,
    JAPAN_SHIP_N,
    KOREA_SHIP_H,
    KOREA_SHIP_N,
    TAIPEI_SHIP_H,
    TAIPEI_SHIP_N,

    //用户
    SHIPORTICON_N: SHIPORTICON_N,
    SHIPORTICON_V: SHIPORTICON_V,


    CHLA_LG: CHLA_LG,
    rtofs_LG: rtofs_LG,
    rtofst_LG: rtofst_LG,
    rtofsuv_LG: rtofsuv_LG,
    SF_LG: SF_LG,
    SSH_LG: SSH_LG,
    SSHA_LG: SSHA_LG,
    SST_LG: SST_LG,
    SSTA_LG: SSTA_LG,
    Typhoon_LG: Typhoon_LG,
    WAVE_LG: WAVE_LG,
    WIND10M_LG: WIND10M_LG,

    //关注
    FOCUS_N: FOCUS_N,
    FOCUS_V: FOCUS_V,

    //起终点
    START: START,
    END: END,
    ///用于单点查询
    singlehyysbw: singlehyysbw,
    singlehyysbwjp: singlehyysbwjp,
    singlehyysfc: singlehyysfc,
    singlehyysgdjp: singlehyysgdjp,
    singlehyyshl: singlehyyshl,
    singlehyyshmgd: singlehyyshmgd,
    singlehyysqy: singlehyysqy,
    singlehyyssw: singlehyyssw,
    singlehyysyl: singlehyysyl,
    singlehyysyls: singlehyysyls,
    singlehyysbmyl: singlehyysbmyl,
    SINGLE_N: SINGLE_N,
    SINGLE_V: SINGLE_V,
    dangqianweizhi: dangqianweizhi,

    FISH_N: FISH_N,
    FISH_V: FISH_V,

    WMAP_N: WMAP_N,
    WMAP_V: SMAP_V,
    NMAP_N: NMAP_N,
    NMAP_V: SMAP_V,
    SMAP_N: SMAP_N,
    SMAP_V: SMAP_V,

    CLOSE_N: CLOSE_N,
    CLOSE_V: CLOSE_V,
    INFO: INFO,
    POS: POS,
    BOAT: BOAT,
    ADD: ADD,
    SUBTRACT: SUBTRACT,
    SINGLECHART: SINGLECHART,
    SINGLEVCHART: SINGLEVCHART,
    BOAT_N: BOAT_N,
    BOAT_V: BOAT_V,
    FOLDER: FOLDER,

    SEARCH_N: SEARCH_N,
    SEARCH_V: SEARCH_V,
    MENU_N: MENU_N,
    MENU_V: MENU_V,

    SHRINK: SHRINK,
    EXPAND: EXPAND,

    CHAT: CHAT,
    FLOG: FLOG,
    ADDRESS: ADDRESS,

    LEFT_N: LEFT_N,
    LEFT_V: LEFT_V,
    RIGHT_N: RIGHT_N,
    RIGHT_V: RIGHT_V,
    MOUSE: MOUSE,
    PANMOUSE: PANMOUSE,
    PANDOWNMOUSE: PANDOWNMOUSE,
    LAYER_N: LAYER_N,
    LAYER_V: LAYER_V,
    DETAIL_N: DETAIL_N,
    DETAIL_V: DETAIL_V,
    LOGINOUT_N: LOGINOUT_N,
    LOGINOUT_V: LOGINOUT_V,
    HELP_N: HELP_N,
    HELP_V: HELP_V,
    LABEL: LABEL,
    TRIALICON: TRIALICON,
    ARROW: ARROW,
    EDIT_N: EDIT_N,
    EDIT_V: EDIT_V,
    DELETE_N: DELETE_N,
    DELETE_V: DELETE_V,
    STOPDRAW_N: STOPDRAW_N,
    STOPDRAW_V: STOPDRAW_V,

    FISHONE_N: FISHONE_N,
    FISHONE_V: FISHONE_V,
    FISHTWO_N: FISHTWO_N,
    FISHTWO_V: FISHTWO_V,
    FISHTHREE_N: FISHTHREE_N,
    FISHTHREE_V: FISHTHREE_V,

    DRAWRECT_N: DRAWRECT_N,
    DRAWRECT_V: DRAWRECT_V,
    DRAWARROW_N: DRAWARROW_N,
    DRAWARROW_V: DRAWARROW_V,
    DRAWWORD_N: DRAWWORD_N,
    DRAWWORD_V: DRAWWORD_V,
    DRAWLINE_N: DRAWLINE_N,
    DRAWLINE_V: DRAWLINE_V,

    TOOL_N: TOOL_N,
    TOOL_V: TOOL_V,

    SWITCH_N: SWITCH_N,
    SWITCH_V: SWITCH_V,
    LINE: LINE,
    FISHERRECT_N: FISHERRECT_N,
    FISHERRECT_V: FISHERRECT_V,
    STOP: STOP,
    PLAY: PLAY,

    DRAW_FISHER: DRAW_FISHER,

    FISHER_PRE: FISHER_PRE,

    FILTER_FISHER: FILTER_FISHER,

    FISHER_LOG: FISHER_LOG,

    CHANGE_PASS: CHANGE_PASS,

    PERFISSION_PIC: PERFISSION_PIC,
    SHARE: SHARE,
    PLAY_1: PLAY_1,
    STOP_1: STOP_1,
    Z: Z,
    Y: Y,
    BEHAVIOR_ANALYSIS,
    ZTT


};

export default sysIconConf;


// WEBPACK FOOTER //
// ./src/store/sysIconsConf.js